import { Component, OnInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';



@Component({
  selector: 'app-nica-popup-wrapper',
  templateUrl: './nica-popup-wrapper.component.html',
  styleUrls: ['./nica-popup-wrapper.component.css']
})
export class NicaPopupWrapperComponent implements OnInit {
  popups:any[]=[];
  classe:string;
  classSlideCenter:string = 'slide-center'
  classFadeIn:string = "fade-in-fwd"
  constructor(private camponentService: ComponentService) { 

    

  }

  ngOnInit() {

      this.camponentService.popupsSet.subscribe(currentSetPopups => {
        currentSetPopups.forEach((res,i)=>{
          console.log('stampoooooooo', currentSetPopups)
          if(res.action == 'added'){
            res.action = 'setted';
            res.class = this.classSlideCenter;
          
            this.popups.push(res)
          }

          if(res.action == 'update'){
            res.action = 'setted';
            
            res.class = "fade-out-bck";
            this.popups.splice(i,1); 
            res.class = this.classSlideCenter;
            setTimeout(() => {
                            
              this.popups.push(res)
              
             
            
            }, 500);
            
           
            
          }

          if(res.action == 'remove'){
          
            
            res.class = "fade-out-bck";
            
            setTimeout(() => {
              this.popups.splice(i,1); 
              
            }, 300);

              
          }
          
        })
      
        //this.camponentService.setPopUps(this.popups)
    })
   

  }

}
